module.exports = __webpack_public_path__ + "assets/webgl/Assets_4_base_color.jpg.dxt.58575925.ktx";